import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/carts',
    name: 'carts',
    meta: {
      title: 'Carts'
    },
    component: () => import('@/views/carts/CartDefaultListView.vue')
  },
  {
    path: '/custom-list-view/:id',
    name: 'custom-list-view',
    props: true,
    meta: {
      title: 'Custom List View'
    },
    component: () => import('@/views/carts/CustomListView.vue')
  },
  {
    path: '/carts/:id',
    name: 'cart-edit',
    props: true,
    meta: {
      title: 'Edit Cart'
    },
    component: () => import('@/views/carts/CartEditView.vue'),
    children: [
      {
        path: '/carts/:id/f/:section',
        name: 'cart-edit-section',
        props: true,
        meta: {
          title: 'Edit Cart'
        },
        component: () => import('@/views/carts/CartEditView.vue')
      },
      {
        path: '/carts/:id/f/:section/:subsection',
        name: 'cart-edit-subsection',
        props: true,
        meta: {
          title: 'Edit Cart'
        },
        component: () => import('@/views/carts/CartEditView.vue')
      }
    ]
  },
  {
    path: '/carts-v2/:id',
    name: 'cart-edit-v2',
    props: true,
    meta: {
      title: 'Edit Cart'
    },
    component: () => import('@/views/carts/v2/CartEditViewV2.vue'),
    children: [
      {
        path: '/carts-v2/:id/f/:section',
        name: 'cart-edit-v2-section',
        props: true,
        meta: {
          title: 'Edit Cart'
        },
        component: () => import('@/views/carts/v2/CartEditViewV2.vue')
      }
    ]
  }
]

export default routes
